export class SweetFaceTerminalDto {
  // @ApiProperty({
  //   description: 'Terminal ID',
  //   example: 1,
  // })
  readonly id: number;

  // @ApiProperty({
  //   description: 'Human readable terminal name',
  //   example: 'Pieshop Terminal 1',
  // })
  readonly name: string;

  // @ApiProperty({
  //   description: 'Bank terminal ID',
  // })
  readonly bankTerminalId: string;

  // @ApiProperty({ description: 'Bank Merchant ID' })
  readonly bankMID: string;

  // @ApiProperty({
  //   description: 'Pie API Key',
  //   example: '123e4567-e89b-12d3-a456-426614174000',
  // })
  readonly pieApiKey: string;

  // @ApiProperty({
  //   description: 'Pie Merchant ID',
  //   example: 1,
  //   type: Number,
  // })
  readonly pieMerchantId: number;
}
